import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/components/ui/use-toast'
import { deleteMarketResearch } from '@/api/business/marketResearch'
import { MarketResearchKeys } from '@/queries/useMarketResearchQuery'
import { isAxiosError } from '@/api/business'
import Button from '@/components/Button'
import { useNavigate } from 'react-router-dom'

interface DeleteDialogProps {
    skPesquisa: number
    nmPesquisa: string
    isOpen: boolean
    onClose: () => void
}

const DeleteMarketResearchDialog = ({ skPesquisa, nmPesquisa, isOpen, onClose }: DeleteDialogProps) => {
    const queryClient = useQueryClient()
    const { toast } = useToast()
    const navigate = useNavigate()

    const { mutate: mutateDelete, isPending: mutateLoading } = useMutation({
        mutationFn: deleteMarketResearch,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: MarketResearchKeys.lists() })
            onClose()
            toast({
                title: 'Pesquisa excluída com sucesso',
            })
            navigate('/market-research')
        },
        onError: (err) => {
            let errorMessage =
                'Não foi possível excluir a pesquisa. Tente novamente mais tarde.'

            if (isAxiosError(err)) {
                errorMessage = err.response?.data.message || errorMessage
            }

            toast({
                title: 'Erro ao excluir pesquisa',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Excluir Pesquisa</DialogTitle>
                </DialogHeader>
                <div className="pt-4">
                    <p>
                        Realmente deseja excluir a pesquisa <strong>{nmPesquisa}</strong>?
                    </p>
                    <p className="text-sm text-muted-foreground mt-2">
                        Esta ação não pode ser desfeita.
                    </p>
                </div>
                <DialogFooter>
                    <Button onClick={onClose} variant="ghost">
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => mutateDelete({ SK_PESQUISA: skPesquisa })}
                        isLoading={mutateLoading}
                        variant="destructive"
                    >
                        Excluir
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteMarketResearchDialog
